export default [
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/login/index.vue"),
    meta: {
      title: "登录",
      keep: true, // 是否需要缓存页面
    },
  },
];
